import { Component, OnInit, Input } from '@angular/core';
import { GroupQuestion } from '../../models/group-question';
import { TutorizationGroupService } from '../../services/tutorization-group.service';
import { Router } from '@angular/router';
import { CANCELLED, CERTIFIED, DISPUTED, PUBLISHED, TUTORING_BUTTON_ACTIONS } from '../../../assets/constants';

@Component({
  selector: 'lms-group-questions-list-row',
  templateUrl: './group-questions-list-row.component.html',
  styleUrls: ['./group-questions-list-row.component.scss']
})
export class GroupQuestionsListRowComponent implements OnInit {
  @Input() public question: GroupQuestion;
  public correctChoice: any;
  public status: string;
  public buttonList = TUTORING_BUTTON_ACTIONS;
  private refresh = true;
  private statusTranslationMap = {
    [DISPUTED]: 'questions.status.disputed',
    [CANCELLED]: 'questions.status.cancelled',
    [CERTIFIED]: 'questions.status.certified',
    [PUBLISHED]: 'questions.status.published'
  };

  constructor(public actions: TutorizationGroupService, public router: Router) {
    this.correctChoice = { text: '' };
    this.status = '';
  }

  public ngOnInit() {
    this.status = this.statusTranslationMap[this.question.status] || 'questions.status.default';
    this.correctChoice = this.question.choices.find((choice) => choice.isCorrect);
    if (!this.correctChoice) {
      this.correctChoice = { text: '' };
    }
  }

  public selectAction(key) {
    switch (key) {
      case '1':
        this.certifyQuestion();
        break;
      case '2':
        this.publishQuestion();
        break;
      case '3':
        this.cancelQuestion();
        break;
      case '4':
        this.deleteQuestion();
        break;
      case '5':
        this.router.navigate(['/tutorization/group-questions', this.question.id]);
        break;
    }
  }

  private certifyQuestion() {
    this.actions.certifyQuestion(this.question.id, this.refresh);
  }

  private publishQuestion() {
    this.actions.publishQuestion(this.question.id, this.refresh);
  }

  private cancelQuestion() {
    this.actions.cancelQuestion(this.question.id, this.refresh);
  }

  private deleteQuestion() {
    this.actions.deleteQuestion(this.question.id, this.refresh);
  }
}
